import http from 'hub-http/clients/apiClient';
const BASE_URL = '/forms/app/v1';
const postAddNewWorkflow = (guid, sourceApp) => http.post(`${BASE_URL}/simple-flow`, {
  data: {
    formGuid: guid,
    sourceApp
  }
});
export default postAddNewWorkflow;